<template>
  <!-- 国际选择州/城市弹窗 -->
  <popup :show="show"
         title="州/市"
         :confirm-btn="false"
         @close="() => { $emit('close') }">
    <div class="cascader-container">
      <div class="cascader-tabs">
          <div
               class="cascader-tab"
               :class="{ 'is-active' : tabActive === 1 }"
               @click="handleCascaderTabClick(1)">
            <div class="tab-title">
              {{ selectItem.userProvince || '请选择' }}
            </div>
          </div>
          <div v-if="intCityList.length"
               :class="{ 'is-active' : tabActive === 2 }"
               class="cascader-tab"
               @click="handleCascaderTabClick(2)">
            <div class="tab-title">
              {{ selectItem.userCity || '请选择' }}
            </div>
          </div>
          <div v-if="intCountyList.length"
               :class="{ 'is-active' : tabActive === 3 }"
               class="cascader-tab"
               @click="handleCascaderTabClick(3)">
            <div class="tab-title">
              {{ selectItem.userArea || '请选择' }}
            </div>
          </div>
      </div>
      <div v-show="tabActive===1" class="cascader-list">
        <div v-for="(item, index) in intProvList"
             :key="index"
             class="cascader-item"
             :class="{ 'active': selectItem.userProvince === item.stateOrProvinceName }"
             @click="handleCascaderItemClick(item)">
          <div class="cascader-name">
            <!-- <span class="char-style">{{ index === 0 ? getHeadChar(item.stateOrProvinceName) : '' }}
              {{ (index !== 0 && (getHeadChar(intProvList[index].stateOrProvinceName) !== getHeadChar(intProvList[index - 1].stateOrProvinceName))) ?
                getHeadChar(item.stateOrProvinceName) :
                ''
              }}</span> -->
            <span>{{ item.stateOrProvinceName }}</span>
          </div>
          <i class="iconfont"
             :class="selectItem.userProvince === item.stateOrProvinceName ? 'icon-check-circle' : 'icon-check-button-off'" />
        </div>
      </div>
      <div v-show="tabActive===2" class="cascader-list">
        <div v-for="(item, index) in intCityList"
             :key="index"
             class="cascader-item"
             :class="{ 'active': selectItem.userCity === item.cityName }"
             @click="handleCascaderItemClick(item)">
          <div class="cascader-name">
            <!-- <span class="char-style">{{ index === 0 ? getHeadChar(item.cityName) : '' }}
              {{ (index !== 0 && (getHeadChar(intCityList[index].cityName) !== getHeadChar(intCityList[index - 1].cityName))) ?
                getHeadChar(item.cityName) :
                ''
              }}</span> -->
            <span>{{ item.cityName }}</span>
          </div>
          <i class="iconfont"
             :class="selectItem.userCity === item.cityName ? 'icon-check-circle' : 'icon-check-button-off'" />
        </div>
      </div>
      <div v-show="tabActive===3" class="cascader-list">
        <div v-for="(item, index) in intCountyList"
             :key="index"
             class="cascader-item"
             :class="{ 'active': selectItem.userArea === item.county }"
             @click="handleCascaderItemClick(item)">
          <div class="cascader-name">
            <!-- <span class="char-style">{{ index === 0 ? getHeadChar(item.county) : '' }}
              {{ (index !== 0 && (getHeadChar(intCountyList[index].county) !== getHeadChar(intCountyList[index - 1].county))) ?
                getHeadChar(item.county) :
                ''
              }}</span> -->
            <span>{{ item.county }}</span>
          </div>
          <i class="iconfont"
             :class="selectItem.userArea === item.county ? 'icon-check-circle' : 'icon-check-button-off'" />
        </div>
      </div>
    </div>
  </popup>
</template>
<script>
import popup from '@/components/popup/index.vue'

export default {
  name: 'cascaderPopup',
  mixins: [],
  components: {
    popup
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    intProvList: {
      type: Array,
      default: () => []
    },
    intCityList: {
      type: Array,
      default: () => []
    },
    intCountyList: {
      type: Array,
      default: () => []
    },
    selectItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      /** 当前展示的数据 */
      currentListData: [],
      tabActive: 1
    }
  },
  computed: {},
  watch: {
  },
  filters: {},
  directives: {},
  created () {},
  mounted () {
  },
  methods: {
    // 获取首字母
    getHeadChar (enName) {
      let name = enName
      return name.charAt(0).toUpperCase()
    },
    /** 联动标题点击事件 */
    handleCascaderTabClick (index) {
      this.tabActive = index
    },
    /** 联动选项点击事件 */
    handleCascaderItemClick (data) {
      if (this.tabActive === 1) {
        this.$emit('clickItem', data)
      } else {
        this.$emit('finish', data)
        this.$emit('close')
      }
    }
  }
}

</script>
<style lang="scss" scoped>
@import "./index";
</style>
